// MAGIC_DESPROCKET_START
require('javascripts/jquery/jquery-1.12.4.js')
require('javascripts/jquery.ui.sortable/jquery-ui-1.9.2.sortable.js')
require('javascripts/jquery/jquery-ujs-2.1.2.js')
require('javascripts/jquery/jquery-migrate-1.4.1.js')
// MAGIC_DESPROCKET_END
